import styled from 'styled-components';

const InfoBox = styled.div`
  background-color: ${(props) => props.theme.colors.inactive};
  border-radius: 6px;
  padding: 8px;
  font-size: 13px;
  color: ${(props) => props.theme.colors.white};
  text-align: center;
`;

export default { InfoBox };
